import dynamic from 'next/dynamic';

import styles from './index.module.scss';

const Typography = dynamic(() => import('#app/UI/atoms/typography-updated'));

const TestimonyCard = ({ testimony }) => {
  return (
    <li className={styles.card} style={{ backgroundColor: testimony.background }}>
      <Typography tag="body-small">{testimony.description}</Typography>

      <footer className="flex gap-x-8">
        {/* Image */}
        <div className={styles.flag}>{testimony.flag}</div>

        {/* Description */}
        <div>
          <Typography className="pt-6" tag="h4">
            {testimony.name}
          </Typography>

          <Typography tag="tags">{testimony.subtitle}</Typography>
        </div>
      </footer>
    </li>
  );
};

export default TestimonyCard;
